import { z } from "zod";

const columnFilterItemSchema = z.object({
  id: z.string(),
  value: z.object({
    op: z.string(),
    value: z.unknown(),
  }),
});

export type ServerColumnFilter = z.infer<typeof columnFilterItemSchema>;

export const columnFilterSchema = z.array(columnFilterItemSchema).optional();
